// extracted by mini-css-extract-plugin
module.exports = {"yearly_content":"subtype-button_yearly_content__gWfYm","not_selected":"subtype-button_not_selected__zhx5E"};